import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useParams, useHistory } from 'react-router-dom';

import api from '../../services/api';
import Breadcrumbs from '../../components/ui/Breadcrumbs';
import Tabs from '../../components/ui/Tabs';
import GeneralTab from './tab-pages/GeneralTab';
import AssignmentsTab from './tab-pages/AssignmentsTab';

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const StickyHeader = styled.div`
  flex-shrink: 0;
`;

const TabContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding-top: 8px;
`;

export default function BenefitPackageDetailsPage() {
  const { t } = useTranslation();
  const { id } = useParams();
  const history = useHistory();

  const [pkg, setPkg] = useState(null);
  const [activeTab, setActiveTab] = useState('general');

  const fetchPackage = useCallback(async () => {
    try {
      const res = await api.get(`/v1/benefit-packages/${id}`);
      setPkg(res.data?.data);
    } catch {
      history.push('/benefit-packages');
    }
  }, [id, history]);

  useEffect(() => { fetchPackage(); }, [fetchPackage]);

  const tabs = [
    { key: 'general', label: t('benefitPackage.tabGeneral') },
    { key: 'assignments', label: t('benefitPackage.tabAssignments') },
  ];

  return (
    <PageContainer>
      <StickyHeader>
        <Breadcrumbs items={[
          { label: t('benefitPackage.title'), path: '/benefit-packages' },
          { label: pkg?.name || '...' },
        ]} />
        <Tabs tabs={tabs} activeTab={activeTab} onChange={setActiveTab} />
      </StickyHeader>

      <TabContent>
        {activeTab === 'general' && <GeneralTab pkg={pkg} onPackageChanged={fetchPackage} />}
        {activeTab === 'assignments' && <AssignmentsTab packageId={id} onAssignmentsChanged={fetchPackage} />}
      </TabContent>
    </PageContainer>
  );
}
